// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member-info-content .ant-card {
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: var(--shadow-sm);
  transition: all 0.4s ease;
}
.member-info-content .ant-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-float);
}
.member-info-content .ant-card.member-status-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.7));
  border: 1px solid rgba(250, 173, 20, 0.2);
}
.member-info-content .ant-card.member-status-card .ant-card-head {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.member-info-content .ant-statistic {
  text-align: center;
}
.member-info-content .ant-statistic .ant-statistic-title {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 8px;
}
.member-info-content .ant-statistic .ant-statistic-content {
  font-size: 24px;
  font-weight: 700;
  font-family: 'Outfit', sans-serif;
  transition: all 0.3s ease;
}
.member-info-content .ant-tag {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  border-radius: 6px;
  padding: 4px 10px;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.member-info-content .ant-tag .anticon {
  margin-right: 6px;
}
.member-info-content .ant-badge-ribbon .ant-badge-ribbon-text {
  font-size: 12px;
  font-weight: 700;
}
.member-info-content .ant-alert {
  border-radius: 12px;
  margin-bottom: 16px;
  border: none;
  box-shadow: var(--shadow-sm);
}
.member-info-content .ant-alert.ant-alert-success {
  background: rgba(240, 253, 244, 0.7);
  backdrop-filter: blur(8px);
}
.member-info-content .ant-alert.ant-alert-success .ant-alert-icon {
  color: #16a34a;
}
.member-info-content .ant-alert.ant-alert-info {
  background: rgba(224, 242, 254, 0.7);
  backdrop-filter: blur(8px);
}
.member-info-content .ant-alert.ant-alert-info .ant-alert-icon {
  color: #0284c7;
}
.member-info-content .ant-descriptions .ant-descriptions-item-label {
  font-weight: 600;
  color: #475569;
  background: transparent;
}
.member-info-content .ant-descriptions .ant-descriptions-item-content {
  color: #1e293b;
}
.member-info-content .member-actions .ant-btn {
  margin-right: 12px;
  margin-bottom: 12px;
}
.member-info-content .member-actions .ant-btn:last-child {
  margin-right: 0;
}
.member-info-content .member-usage-tips ul {
  margin: 0;
  padding-left: 16px;
}
.member-info-content .member-usage-tips ul li {
  margin-bottom: 8px;
  line-height: 1.6;
  color: #64748b;
}
.member-status-gold {
  color: #d97706;
  font-weight: 700;
}
.member-status-default {
  color: #64748b;
}
.bean-coins-display .anticon {
  color: #f59e0b;
  filter: drop-shadow(0 2px 4px rgba(245, 158, 11, 0.3));
}
@media (max-width: 768px) {
  .member-info-content .ant-statistic .ant-statistic-content {
    font-size: 20px;
  }
  .member-info-content .ant-card {
    margin-bottom: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/renderer/components/MemberInfo.less"],"names":[],"mappings":"AAAA;EAEI,mBAAA;EACA,oCAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,yBAAA;AAAJ;AAEI;EACE,2BAAA;EACA,+BAAA;AAAN;AAGI;EACE,uFAAA;EACA,yCAAA;AADN;AADI;EAKI,4CAAA;AADR;AAlBA;EAyBI,kBAAA;AAJJ;AArBA;EA4BM,eAAA;EACA,cAAA;EACA,kBAAA;AAJN;AA1BA;EAkCM,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,yBAAA;AALN;AAhCA;EA0CI,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,yCAAA;AAPJ;AAzCA;EAmDM,iBAAA;AAPN;AA5CA;EAyDM,eAAA;EACA,gBAAA;AAVN;AAhDA;EA+DI,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,4BAAA;AAZJ;AAcI;EACE,oCAAA;EACA,0BAAA;AAZN;AAUI;EAKI,cAAA;AAZR;AAgBI;EACE,oCAAA;EACA,0BAAA;AAdN;AAYI;EAKI,cAAA;AAdR;AApEA;EAyFM,gBAAA;EACA,cAAA;EACA,uBAAA;AAlBN;AAzEA;EA+FM,cAAA;AAnBN;AA5EA;EAqGM,kBAAA;EACA,mBAAA;AAtBN;AAwBM;EACE,eAAA;AAtBR;AAnFA;EAgHM,SAAA;EACA,kBAAA;AA1BN;AAvFA;EAoHQ,kBAAA;EACA,gBAAA;EACA,cAAA;AA1BR;AAiCA;EACE,cAAA;EACA,gBAAA;AA/BF;AAkCA;EACE,cAAA;AAhCF;AAoCA;EAEI,cAAA;EACA,sDAAA;AAnCJ;AAwCA;EACE;IAGM,eAAA;EAxCN;EAqCA;IAQI,mBAAA;EA1CJ;AACF","sourcesContent":[".member-info-content {\n  .ant-card {\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(12px);\n    border: 1px solid rgba(255, 255, 255, 0.5);\n    box-shadow: var(--shadow-sm);\n    transition: all 0.4s ease;\n    \n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: var(--shadow-float);\n    }\n    \n    &.member-status-card {\n      background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.7));\n      border: 1px solid rgba(250, 173, 20, 0.2);\n      \n      .ant-card-head {\n        border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n      }\n    }\n  }\n\n  .ant-statistic {\n    text-align: center;\n    \n    .ant-statistic-title {\n      font-size: 13px;\n      color: #64748b;\n      margin-bottom: 8px;\n    }\n    \n    .ant-statistic-content {\n      font-size: 24px;\n      font-weight: 700;\n      font-family: 'Outfit', sans-serif;\n      transition: all 0.3s ease;\n    }\n  }\n\n  .ant-tag {\n    display: inline-flex;\n    align-items: center;\n    font-weight: 600;\n    border-radius: 6px;\n    padding: 4px 10px;\n    border: none;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    \n    .anticon {\n      margin-right: 6px;\n    }\n  }\n\n  .ant-badge-ribbon {\n    .ant-badge-ribbon-text {\n      font-size: 12px;\n      font-weight: 700;\n    }\n  }\n\n  .ant-alert {\n    border-radius: 12px;\n    margin-bottom: 16px;\n    border: none;\n    box-shadow: var(--shadow-sm);\n    \n    &.ant-alert-success {\n      background: rgba(240, 253, 244, 0.7);\n      backdrop-filter: blur(8px);\n      \n      .ant-alert-icon {\n        color: #16a34a;\n      }\n    }\n    \n    &.ant-alert-info {\n      background: rgba(224, 242, 254, 0.7);\n      backdrop-filter: blur(8px);\n      \n      .ant-alert-icon {\n        color: #0284c7;\n      }\n    }\n  }\n\n  .ant-descriptions {\n    .ant-descriptions-item-label {\n      font-weight: 600;\n      color: #475569;\n      background: transparent;\n    }\n    \n    .ant-descriptions-item-content {\n      color: #1e293b;\n    }\n  }\n\n  .member-actions {\n    .ant-btn {\n      margin-right: 12px;\n      margin-bottom: 12px;\n      \n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  }\n\n  .member-usage-tips {\n    ul {\n      margin: 0;\n      padding-left: 16px;\n      \n      li {\n        margin-bottom: 8px;\n        line-height: 1.6;\n        color: #64748b;\n      }\n    }\n  }\n}\n\n// 会员状态相关样式\n.member-status-gold {\n  color: #d97706;\n  font-weight: 700;\n}\n\n.member-status-default {\n  color: #64748b;\n}\n\n// 积分相关样式\n.bean-coins-display {\n  .anticon {\n    color: #f59e0b;\n    filter: drop-shadow(0 2px 4px rgba(245, 158, 11, 0.3));\n  }\n}\n\n// 响应式设计\n@media (max-width: 768px) {\n  .member-info-content {\n    .ant-statistic {\n      .ant-statistic-content {\n        font-size: 20px;\n      }\n    }\n    \n    .ant-card {\n      margin-bottom: 16px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
